module.exports = __webpack_public_path__ + "static/media/Builders_logo_SA_RGB.02c5efed.svg";